import { useContext, useState } from "react";
import RequiredDocumentsModal from "../../pages/onboarding/RequiredDocumentsModal";
import constants from "../../Utils/constants";
import DocumentAnalysisLoadingPopup from "../Onboarding/DocumentAnalysisLoading";
import TenantContext from "../../context/tenant/TenantContext";
import useTranslator from "../../hooks/useTranslator";
import { toast } from "../../helper/common";

const DocUploadingComponentWithAnalysing = ({
  isOpen,
  onClose,
  user,
  fetchFileDataParent,
  isGuarantor,
}) => {
  const { _t } = useTranslator();
  const [docAnalysisLoading, setDocAnalysisLoading] = useState(false);
  const { checkDocumentAnalysisStatus } = useContext(TenantContext);
  const [reloadDocsTrigger, setReloadDocsTrigger] = useState(false);
  let redirectUrl = "home";
  const queryParams = window.location.search;

  if (queryParams && queryParams.length > 0) {
    redirectUrl = `home${queryParams}&uploadDocModel=true&waiting=`;
  } else {
    redirectUrl = `home?uploadDocModel=true&waiting=`;
  }

  const checkDocumentAnalysis = async () => {
    const tenantId = user?._id;
    if (!tenantId) return;

    const interval = setInterval(async () => {
      try {
        const res = await checkDocumentAnalysisStatus(tenantId);

        if (res?.success_res?.status === "done") {
          clearInterval(interval);
          setDocAnalysisLoading(false);
          setReloadDocsTrigger((prev) => !prev);
          fetchFileDataParent();
          return;
        }

        if (res?.success_res?.status === "failed") {
          clearInterval(interval);
          setDocAnalysisLoading(false);
          toast.error(
            _t(
              "documentAnalysisFailedPleaseReUpload",
              "Text used in onboarding flow"
            )
          );
          return;
        }

        if (res?.success_res?.status === "processing") {
          setDocAnalysisLoading(true);
          return;
        }

        console.warn("Unexpected status or missing data", res);
        clearInterval(interval);
      } catch (error) {
        console.error("Error checking document analysis:", error);
        clearInterval(interval);
        setDocAnalysisLoading(false);
      }
    }, 5000);
  };

  if (!isOpen) return;

  const requiresSubcategory = (status) => {
    return [
      constants.public_servant,
      constants.employed,
      constants.self_employed,
    ].includes(status);
  };

  return (
    <>
      <RequiredDocumentsModal
        formHandler={() => {}}
        user={user}
        requiresSubcategory={requiresSubcategory}
        updateUserProfile={() => {}}
        isGuarantor={isGuarantor}
        isFirstTime={false}
        reqFor={"updateDoc"}
        onClose={onClose}
        checkDocumentAnalysis={checkDocumentAnalysis}
        redirectUrl={redirectUrl}
        setDocAnalysisLoading={setDocAnalysisLoading}
        isOpen={isOpen}
        reloadTrigger={reloadDocsTrigger}
        needWaitingJobForClave={true}
        fetchFileDataParent={fetchFileDataParent}
      />
      <DocumentAnalysisLoadingPopup showPopup={docAnalysisLoading} />
    </>
  );
};

export default DocUploadingComponentWithAnalysing;
